import React, { useContext, useEffect } from 'react';
import { View, Text, ScrollView } from 'react-native';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { CommonActions, useNavigation } from '@react-navigation/native';
import CustomPressable from '../../components/customPressable/customPressable';
import { useDispatch, useSelector } from 'react-redux';
import { getDigitalKeySupportedAuthMethods, requestOTP, validateDigitalKey } from '../../Redux/Actions/doorKeyAction';
import { setGoHome, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { DOOR_KEY, DoorKeyContext, OTP_SCREEN } from '../../navigation/StackNavigator/doorKeyNavigator';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { DOOR_KEY_CATEGORY } from '../../config/Constant';

const ValidationOptions = () => {

    const { widgetSessionId, widgetLaunchTime } = useContext(DoorKeyContext);

    const navigation = useNavigation();
    const dispatch = useDispatch();
    const getStyles = useCssStyle();
    const { t } = useTranslation();


    const { isLoggedIn } = useSelector(state => state.appConfigSlice);

    const { supportedMethods, loading } = useSelector(state => state.doorKeySlice);
    const { currentGuestDetails } = useSelector(state => state.guestDetailsSlice);

    let reservationNumber = currentGuestDetails?.reservationNumber
    let locationId = currentGuestDetails?.location
    const isOtpAvailable = supportedMethods?.some((m) => m.toLowerCase().includes('otp'));
    const isFrontdeskAvailable = supportedMethods?.some((m) => m.toLowerCase().includes('frontdesk'));

    const [doorkeyLoading, setDoorKeyLoading] = React.useState(loading);
    const [loaderMessage, setLoaderMessage] = React.useState('');

    const handleOtpPress = async () => {
        // Handle OTP press action
        setLoaderMessage(t('doorkey.sendOTP'))
        setDoorKeyLoading(true)
        dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "OTP VERIFICATION", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": "OTP VERIFICATION"}));
        
        dispatch(requestOTP(reservationNumber, locationId, (status, message) => {
            if (status) {
                navigation.navigate(OTP_SCREEN);
            } else if(message) {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: message || "Something went wrong" }))
                
                dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "OTP VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": "OTP VERIFICATION", "errorMessage": message || "Error while calling digital key api: requestOTP"}));
            }
            setDoorKeyLoading(false)
        }));

        // navigation.navigate(OTP_SCREEN);
        if (supportedMethods?.status === 200) {
            navigation.navigate(OTP_SCREEN);
        }
    };

    const handleValidatePress = async () => {
        // Handle validate at front desk press action
        setLoaderMessage(t('doorkey.validating'))
        setDoorKeyLoading(true)
        
        dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "FRONT DESK VERIFICATION", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": "FRONT DESK VERIFICATION"}));

        dispatch(validateDigitalKey(reservationNumber, locationId, "keyRequest", async (status, message)=>{
            setDoorKeyLoading(false);

            if(status){
                dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "FRONT DESK VERIFICATION - SUCCESS", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": "FRONT DESK VERIFICATION"}));

                await AsyncStorage.setItem('doorkeyValidation', JSON.stringify(status));
                navigation.reset({
                    index: 0,
                    routes: [{ name: DOOR_KEY }],
                });
            } else {
                dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "FRONT DESK VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": "FRONT DESK VERIFICATION", "errorMessage": message || "Error while calling digital key api: Frontdesk Validation"}));
                dispatch(setRenderFlashMessage(true, { type: "danger", message: message || "Something went wrong" }))
            }

        }))
    };

    const handleCustomBackPress = () => {
       dispatch(setGoHome(true));
    };

    useEffect(() => {setDoorKeyLoading(loading)}, [loading]);


    useEffect(() => {
        dispatch(sendAnalytics(DOOR_KEY_CATEGORY, "VERIFICATION OPTIONS", { "element": "widget", "widgetSessionId": widgetSessionId, "pageName": "AUTH OPTIONS"}));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        // <View style={getStyles(['mainContainer'])}>

        <View style={getStyles(['widgetRootContainer', 'doorkeyRootContainer'])} id='widgetRootContainer doorkeyRootContainer' >

            <HeaderWithBack handleCustomBackPress={handleCustomBackPress} />
            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainer', 'doorkeyMainContainer'])}
            id='widgetmainContainer doorkeyMainContainer'>
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'doorkeyMainContainerHeaderContainer'])} id='widgetmainContainerHeaderContainer doorkeyMainContainerHeaderContainer'>
                    <View style={[getStyles(['widgetmainContainerHeaderTitleContainer', 'doorkeyMainContainerHeaderTitleContainer'])]} id='widgetmainContainerHeaderTitleContainer doorkeyMainContainerHeaderTitleContainer'>
                        <Text
                            style={getStyles(['widgetmainContainerHeaderTitle', 'doorkeyMainContainerHeaderTitle'])}
                            id='widgetmainContainerHeaderTitle doorkeyMainContainerHeaderTitle'
                        >{t('doorkey.doorkey')}</Text>
                        <Text
                            style={getStyles(['widgetmainContainerHeaderSubTitle', 'doorkeyMainContainerHeaderSubTitle'])}
                            id='widgetmainContainerHeaderSubTitle doorkeyMainContainerHeaderSubTitle'
                        >
                            {t('doorkey.select_method')}
                        </Text>
                        <Text
                            style={getStyles(['widgetmainContainerHeaderSubTitle', 'doorkeyMainContainerHeaderSubTitle'])}
                            id='widgetmainContainerHeaderSubTitle doorkeyMainContainerHeaderSubTitle'
                        >
                            {t('doorkey.choose_digital')}
                        </Text>
                        <View style={getStyles(['widgetmainContainerChildContainer', 'doorkeyMainContainerChildContainer'])} id='widgetmainContainerChildContainer doorkeyMainContainerChildContainer'>
                            {isOtpAvailable && (
                                <>
                                    <CustomPressable
                                        style={getStyles(['primaryBtn', 'doorKeyButton'])}
                                        onPress={handleOtpPress}
                                        id='primaryBtn doorKeyButton'
                                    >
                                        <Text style={getStyles(['primaryBtnTxt', 'doorKeyButtonText'])} id='primaryBtnTxt doorKeyButtonText'>
                                            {t('doorkey.enter_otp')}
                                        </Text>
                                    </CustomPressable>
                                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'doorkeyMainContainerHeaderSubTitle'])} id='widgetmainContainerHeaderSubTitle doorkeyMainContainerHeaderSubTitle'>
                                        {t('doorkey.otp_reminder')}
                                    </Text>
                                </>
                            )}

                            {isOtpAvailable && isFrontdeskAvailable && (
                                <Text style={getStyles(['doorKeyOrText'])} id='doorKeyOrText'>{t('doorkey.or')}</Text>
                            )}

                            {isFrontdeskAvailable && (
                                <CustomPressable
                                    style={getStyles(['primaryBtn', 'doorKeyButton'])}
                                    onPress={handleValidatePress}
                                    id='primaryBtn doorKeyButton'
                                >
                                    <Text style={getStyles(['primaryBtnTxt', 'doorKeyButtonText'])} id='primaryBtnTxt doorKeyButtonText'>
                                        {t('doorkey.validate')}
                                    </Text>
                                </CustomPressable>
                            )}
                        </View>
                    </View>
                </View>
            </ScrollView>

            {doorkeyLoading && <FetchingDataScreen loaderMessage={loaderMessage}/>}
        </View>
    );
};


export default ValidationOptions;
